import script from "./CustomTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTable.vue?vue&type=script&setup=true&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=35b5d43c&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b5d43c"]])

export default __exports__